import {NgModel} from './ngModel';

export const Rfp = NgModel.extend({
    _name: 'RFP',
    urlRoot: '', // we never actually fetch the state, this object is included in the Meeting fetch response
});
